// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W8vm6auw57EkG_tSndyM{flex-direction:column;flex-grow:1;width:760px;margin:0 auto;display:flex}.zPx9FkAnS78Af9rHIvup{justify-content:space-between;align-items:center;padding:64px 20px 0;display:flex}.X80SBl0A7u8gCsPSb2uN{flex-direction:column;gap:2px;height:100%;padding:12px 16px 0;display:flex}.dPuAtwX4_oAsBJKRlDWv{flex-direction:column;gap:4px;display:flex}.lYRIdjfQnkQX_HaJXDmD{gap:8px;display:flex}.a3gaIqFLhVovWtncXK2b{align-items:center;gap:10px;padding:18px 6px 12px;display:flex}.a3gaIqFLhVovWtncXK2b .M0jyZCLYBRkPEI590f4h{flex:1}.a3gaIqFLhVovWtncXK2b .M0jyZCLYBRkPEI590f4h>input{height:24px;font-size:16px;font-style:normal;font-weight:400;line-height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `W8vm6auw57EkG_tSndyM`,
	"pageHeader": `zPx9FkAnS78Af9rHIvup`,
	"pageContent": `X80SBl0A7u8gCsPSb2uN`,
	"headerDetails": `dPuAtwX4_oAsBJKRlDWv`,
	"headerActions": `lYRIdjfQnkQX_HaJXDmD`,
	"search": `a3gaIqFLhVovWtncXK2b`,
	"field": `M0jyZCLYBRkPEI590f4h`
};
export default ___CSS_LOADER_EXPORT___;
